import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router} from 'react-router-dom';

import store from './redux/configure-store';
import App from './App';

ReactDOM.render(
  <Provider store={store()}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);